export default __webpack_public_path__ + "7a3d4f48189515e3bcdb888a1c140762.png";